export default __webpack_public_path__ + "static/media/close-Icon.be415408.svg";